export class ContextMenuDocument {
  label: string;
  id: number;
  uuid?: string;
  associatedStatements?: number[]
  action?: string;
  isVendorData?: boolean;

  constructor(label, id, associatedStatements = [], uuid?: string, isVendorData = false) {
    this.label = label;
    this.id = id;
    this.associatedStatements = associatedStatements;
    this.uuid = uuid;
    this.isVendorData = isVendorData;
  }
}
